import { Search, SlidersHorizontal } from "lucide-react";
import { useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { OfferingCard } from "@/components/offering-card";
import { offerings } from "@/mocks/residual";
import type { OfferingKind } from "@/types/residual";
const KIND_FILTERS: {
  id: OfferingKind | "all";
  label: string;
}[] = [{
  id: "all",
  label: "All"
}, {
  id: "asset",
  label: "Asset"
}, {
  id: "revenue-share",
  label: "Revenue share"
}];
export function OfferingsPage({
  onSelect
}: {
  onSelect: (offeringId: string) => void;
}) {
  const [query, setQuery] = useState("");
  const [kind, setKind] = useState<OfferingKind | "all">("all");
  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    return offerings.filter(o => o.status !== "draft").filter(o_0 => kind === "all" || o_0.kind === kind).filter(o_1 => q ? `${o_1.title} ${o_1.subtitle} ${o_1.location ?? ""} ${o_1.tags.join(" ")}`.toLowerCase().includes(q) : true);
  }, [query, kind]);
  return <div className="space-y-5">
			<div>
				<h1 className="text-2xl font-semibold tracking-tight">Explore</h1>
				<p className="text-sm text-muted-foreground">
					Fractional ownership and revenue-share deals from vetted partners.
				</p>
			</div>

			<div className="flex gap-2">
				<div className="relative flex-1">
					<Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
					<Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search assets, locations…" className="pl-9" />
				</div>
				<Button variant="outline" size="icon" aria-label="Filters">
					<SlidersHorizontal className="size-4" />
				</Button>
			</div>

			<div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1">
				{KIND_FILTERS.map(f => <button key={f.id} type="button" onClick={() => setKind(f.id)} className={`shrink-0 rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors ${kind === f.id ? "border-foreground bg-foreground text-background" : "bg-background text-foreground hover:bg-muted"}`}>
						{f.label}
					</button>)}
			</div>

			<div className="grid gap-4">
				{visible.length === 0 ? <div className="rounded-2xl border border-dashed p-10 text-center">
						<p className="text-sm text-muted-foreground">
							No offerings match this filter yet.
						</p>
					</div> : visible.map(o_2 => <OfferingCard key={o_2.id} offering={o_2} onClick={() => onSelect(o_2.id)} />)}
			</div>
		</div>;
}